import React, { Component, Fragment } from "react";
import Functions from "../../../src/functions";

class Hybrid extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createDataList = this.createDataList.bind(this);
  }

  componentDidMount() {
    let UserType = Functions["custom"]["getUserType"]();
    let landPageData = JSON.parse(sessionStorage.landPageData);
    //document.getElementById("wrapper").style.background = "#0a3e74";
    // Functions.addCSS("/resources/hybrid_wallets/css/style.css");
    // Functions.addCSS("/resources/hybrid_wallets/css/jquery.jscrollpane.css");
    // Functions.addCSS("/resources/hybrid_wallets/css/mobile.css");
    if (UserType !== "HYBRID_BUSINESS_COST_CONTROL")
      Functions.addCSS("/resources/hybrid_wallets/css/hybrid-wallet-cc.css");
    if (
      UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
      landPageData.contractInfoCarrier.inListOfWhatuspCss
    ) {
      Functions.addCSS(
        "/resources/hybrid_wallets/css/hybrid-wallet-whatsup.css"
      );
    }
    // else if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
    //   Functions.addCSS("/resources/hybrid_wallets/css/hybrid-wallet-bcc.css");
    // }
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  toggleText() {
    let textDisplay = document.getElementsByClassName("text")[0].style;
    textDisplay.display = "block";
    if (textDisplay.opacity === "1") {
      document.getElementById("detailsTitle").classList.remove("active");

      textDisplay.opacity = "0";
    } else {
      document.getElementById("detailsTitle").classList.add("active");

      textDisplay.opacity = "1";
    }
    let panel = document.getElementsByClassName("panel")[0];
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
  clickHandler() {
    let subItems = document.getElementsByClassName("sub-items")[0].style;
    if (
      document.getElementsByClassName("view-more")[0].className ===
      "view-more active"
    ) {
      document
        .getElementsByClassName("view-more")[0]
        .classList.remove("active");
      subItems.display = "none";
    } else {
      document.getElementsByClassName("view-more")[0].classList.add("active");
      subItems.display = "block";
    }
  }

  createDataList() {
    let balanceFormated = sessionStorage.getItem("balanceFormated");
    let UserType = Functions["custom"]["getUserType"]();
    let output = [];

    if (JSON.parse(sessionStorage.getCustomerData).balance >= 0) {
      let creditData = "";
      let contractData = "";
      let contractReloadDateFormated = "";
      let vault = "";
      let businessContractDiv = "";
      let categoryList =
        this.state.data[0].categoriesInfoList.data.categoriesInfoList;
      let bundleList = this.state.data[0].bundlesInfoList.data.bundlesInfoList;

      let lengthOfCategories =
        this.state.data[0].categoriesInfoList.data.categoriesInfoList.length;
      let lengthOfBundles =
        this.state.data[0].bundlesInfoList.data.bundlesInfoList.length;

      if (lengthOfCategories > 0) {
        for (let k = 0; k < lengthOfCategories; k++) {
          let exp = "";
          if (categoryList[k].name === "PwCVault") {
            for (let n = 0; n < lengthOfBundles; n++) {
              if (bundleList[n].category === "PwCVault") {
                exp = bundleList[n].expiration;
              }
            }
            vault = categoryList[k].monetaryValue + "€";
            output.push(
              <div className="item">
                <div className="col first">
                  <img src="/resources/hybrid_wallets/images/icon-hybrid-1.png" />
                </div>
                <div className="col sec">
                  <div className="price">
                    <span className="vault">{vault} </span>
                  </div>
                  Το υπόλοιπο σου μέχρι 14/06
                </div>
                <div className="col last">
                  Διαθέσιμα έως <br />
                  <span className="bundleExpirationVault">{exp}</span>
                </div>
              </div>
            );
          }
          if (categoryList[k].name === "CoreCredit") {
            for (let n = 0; n < lengthOfBundles; n++) {
              if (bundleList[n].category === "CoreCredit") {
                exp = bundleList[n].expiration;
              }
            }
            creditData = categoryList[k].monetaryValue + "€";
            output.push(
              <div className="item">
                <div className="col first">
                  <img src="/resources/hybrid_wallets/images/icon-hybrid-3.png" />
                </div>
                <div className="col sec">
                  <div className="price">
                    <span className="credit">{creditData}</span>
                  </div>
                  Υπόλοιπο από ανανεώσεις
                </div>
                <div className="col last">
                  Διαθέσιμα έως <br />
                  <span className="bundleExpirationCredit">{exp}</span>
                </div>
              </div>
            );
          }
          if (categoryList[k].name === "PwCContract") {
            let subItems = [];
            if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
              let contractPrice = "";
              for (let n = 0; n < lengthOfBundles; n++) {
                if (bundleList[n].category === "PwCContract") {
                  contractPrice = bundleList[n].monetaryValue + "€";
                  exp = bundleList[n].expiration;
                  subItems.push(
                    <div className="sub-item">
                      <div className="sub-item-title">
                        <strong>
                          <span className="contractPrice">{contractPrice}</span>
                        </strong>{" "}
                        λήγουν στις
                      </div>
                      <div className="sub-item-date">
                        <span className="contractExpirationDate">{exp}</span>
                      </div>
                    </div>
                  );
                }
              }
            }
            contractData = categoryList[k].monetaryValue + "€";
            contractReloadDateFormated = JSON.parse(
                sessionStorage.getCustomerData
            ).contractReloadDateFormated;

            output.push(
              <div className="item">
                <div className="col first">
                  <img src="/resources/hybrid_wallets/images/icon-hybrid-2.png" />
                </div>
                <div className="col sec">
                  <div className="price">
                    <span className="contract">{contractData}</span>
                  </div>
                  Υπόλοιπο από το πρόγραμμα σου
                </div>
                <div className="col last">
                  <div className="contractMessage">Ανανεώνεται</div>
                  <span className="bundleExpirationContract">
                    {contractReloadDateFormated}
                  </span>
                </div>
                {UserType === "HYBRID_BUSINESS_COST_CONTROL" ? (
                  <div className="view-more">
                    <a onClick={this.clickHandler}>ΔΕΣ ΑΝΑΛΥΤΙΚΑ</a>
                    <div className="sub-items">{subItems}</div>
                  </div>
                ) : null}
              </div>
            );
          }
        }
        return (
          <div className="moreAmount" style={{ display: "none" }}>
            <div className="header">
              <div className="hold">
                <a className="logo"></a>
              </div>
            </div>
            <div className="hybrid-wallet">
              <div className="balance">
                <div className="title">ΣΥΝΟΛΙΚΟ ΥΠΟΛΟΙΠΟ</div>
                <div className="amount">
                  <span className="customClassBalanceRemaining">
                    {balanceFormated}€
                  </span>
                  <br />
                </div>
              </div>
              <div className="items">{output}</div>
              <a href="/" className="back">
                &lt; ΠΙΣΩ
              </a>
              <div className="notice">
                <div
                  onClick={this.toggleText}
                  className="title"
                  id="detailsTitle"
                >
                  <span className="accordion">Το υπόλοπο σου άλλαξε</span>
                </div>
                <div
                  className="text panel"
                  style={{ transition: "all 0.4s ease 0s" }}
                >
                  Διαχειρίσου το υπόλοιπο σου πιο εύκολα, με τις νέες
                  κατηγορίες!
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="moreAmount" style={{ display: "block" }}>
            <div className="header">
              <div className="hold">
                <a className="logo"></a>
              </div>
            </div>
            <div className="hybrid-wallet">
              <div className="balance">
                <div className="title">ΣΥΝΟΛΙΚΟ ΥΠΟΛΟΙΠΟ</div>
                <div className="amount">
                  <span className="customClassBalanceRemaining">
                    {balanceFormated}€
                  </span>
                  <br />
                </div>
              </div>
              <div className="items">
                <div className="item" id="vault" style={{ display: "none" }}>
                  <div className="col first">
                    <img src="/resources/hybrid_wallets/images/icon-hybrid-1.png" />
                  </div>
                  <div className="col sec">
                    <div className="price">
                      <span className="vault"> </span>
                    </div>
                    Το υπόλοιπο σου μέχρι 14/06
                  </div>
                  <div className="col last">
                    Διαθέσιμα έως <br />
                    <span className="bundleExpirationVault"></span>
                  </div>
                </div>
                <div className="item" id="contract" style={{ display: "none" }}>
                  <div className="col first">
                    <img src="/resources/hybrid_wallets/images/icon-hybrid-2.png" />
                  </div>
                  <div className="col sec">
                    <div className="price">
                      <span className="contract"></span>
                    </div>
                    Υπόλοιπο από το πρόγραμμα σου
                  </div>
                  <div className="col last">
                    <div className="contractMessage">Ανανεώνεται</div>
                    <span className="bundleExpirationContract"></span>
                  </div>
                </div>
                <div className="item" id="credit" style={{ display: "none" }}>
                  <div className="col first">
                    <img src="/resources/hybrid_wallets/images/icon-hybrid-3.png" />
                  </div>
                  <div className="col sec">
                    <div className="price">
                      <span className="credit"></span>
                    </div>
                    Υπόλοιπο από ανανεώσεις
                  </div>
                  <div className="col last">
                    Διαθέσιμα έως <br />
                    <span className="bundleExpirationCredit"></span>
                  </div>
                </div>
              </div>
              <a href="/" className="back">
                &lt; ΠΙΣΩ
              </a>
              <div className="notice">
                <div
                  onClick={this.toggleText}
                  className="title"
                  id="detailsTitle"
                >
                  <span className="accordion">Το υπόλοπο σου άλλαξε</span>
                </div>
                <div
                  className="text panel"
                  style={{ transition: "all 0.4s ease 0s" }}
                >
                  Διαχειρίσου το υπόλοιπο σου πιο εύκολα, με τις νέες
                  κατηγορίες!
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
  }

  render() {
    if (this.state.loaded) {
      return this.createDataList();
    } else {
      return "";
    }
  }
}

export default Hybrid;
